import { WatchQueryFetchPolicy } from "@apollo/client"
import { useScheduleListQuery } from "generated/graphql"
import { omit } from "lodash-es"
import { useSchedulingVariables } from "store/scheduling.redux"
export type SchedulingType = {
  unpaginated?: boolean
  fetchPolicy?: WatchQueryFetchPolicy
}
function useSchedulingQuery({
  unpaginated = false,
  fetchPolicy = undefined,
}: SchedulingType = {}) {
  const defaultVariables = useSchedulingVariables()
  const { data, loading, error, fetchMore } = useScheduleListQuery({
    fetchPolicy: fetchPolicy,
    variables: unpaginated
      ? omit(defaultVariables, ["first", "skip"])
      : defaultVariables,
    notifyOnNetworkStatusChange: true,
  })

  return { data, loading, error, fetchMore }
}

export default useSchedulingQuery
